export const environment = {
    production: true,
    tokenKey: 'access_token',
    apiBaseUrl: 'https://dev.rst.insightscrm.com/api',
    googleApiKey: 'AIzaSyDnAKQZb_QuAlD4rKMN2g_FhgQUDnmBY54',
    conferenceIdKey: 'conference_id'
};